// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CardWrapper__Wrapper_3Y7OX","Name":"CardWrapper__Name__14D0"};